module.exports = __webpack_public_path__ + "static/media/web logos_VEDX.2cd4584d.jpg";